import template from './cardHeader.html';

export const cardHeaderComponent = {
  name: 'cardHeader',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    header: '@',
    subHeader: '@',
    iconClass: '@'
  }
};
